import { computed } from 'mobx';

export default class QCTypeModel {
  id;
  store;

  constructor(store, qcType) {
    this.store = store;
    this.id = +qcType.id;
    this.name = qcType.name;
    this.description = qcType.description;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
  }
}



// WEBPACK FOOTER //
// ./src/models/QCTypeModel.js